import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '../../legacy/components';
import { useAppImage } from '../../legacy/hooks';
import { InfoCard } from './InfoCard';
export function InfoTextCard({ title, titleVariant = 'h4', description, descriptionVariant = 'body2', illustration, }) {
    const AppImage = useAppImage();
    return (_jsx(InfoCard, { title: title ? _jsx(Typography, { variant: titleVariant, children: title }) : null, description: description ? (_jsx(Typography, { variant: descriptionVariant, children: description })) : null, illustration: illustration ? (_jsx(AppImage, { src: illustration, alt: title ?? 'info', fill: true })) : null }));
}
